/**
 * product-price-louer-from.js
 * Renseigne « Dès {mensualité}/mois » du bloc prix (location longue durée).
 * Mensualité = window.getAllPricesForProduct(prixHT)[36].monthly (cf. product-louer-block.js).
 * ⚠️ getAllPricesForProduct attend un prix HT (cf. greenleaze-script.js `productPriceHT`) :
 *    on convertit le TTC → HT via le taux de TVA (mirroir de product-louer-block.js getPriceHT).
 * Resync : 'variant:change' (changement de taille) + 'greenleazePriceActualize'
 *    (le script greenleaze est chargé en async → recalcul quand il est prêt = cold load).
 */
(function () {
  'use strict';
  var el = document.querySelector('[data-louer-from-monthly]');
  var cta = document.querySelector('.product-louer-from__cta');
  if (!el) return;

  var state = {
    priceTTC: cta ? parseInt(cta.dataset.price, 10) : NaN,
    taxable: cta ? cta.dataset.taxable === 'true' : true,
  };

  function fmt(v) {
    return Math.round(v).toLocaleString('fr-FR') + ' €';
  }
  function priceHT() {
    if (isNaN(state.priceTTC)) return null;
    var taxRate = state.taxable ? 1.2 : 1;
    return state.priceTTC / taxRate / 100;
  }

  // Mensualité À AFFICHER : passe par getDisplayPriceForProduct, qui applique le MÊME
  // plancher d'apport que la modale de location (20 % du prix sur les vélos en TVA sur
  // marge) et amortit le supplément par les règles Greenleaze. Sans lui, ce montant repart
  // sur l'apport Greenleaze par défaut et annonce une mensualité PLUS ÉLEVÉE que la modale
  // (Cervélo 3 999 € : 131 € ici, 121,33 € dans la modale — mesuré le 22/09/2026).
  // `marginVat` = variante NON taxable, soit exactement le booléen qui pilote priceHT().
  // Repli sur getAllPricesForProduct si le CDN sert un greenleaze-script.js antérieur à cet
  // ajout : ancien montant (divergent), jamais de montant vide.
  function monthlyForDisplay(ht) {
    var displayed = isNaN(state.priceTTC) ? 0 : state.priceTTC / 100;
    if (typeof window.getDisplayPriceForProduct === 'function') {
      return window.getDisplayPriceForProduct(ht, 36, displayed, !state.taxable).monthly;
    }
    var prices = window.getAllPricesForProduct(ht) || {};
    return prices[36] && prices[36].monthly;
  }

  function update() {
    if (typeof window.getAllPricesForProduct !== 'function') return;
    var ht = priceHT();
    if (!ht) return;
    var m = monthlyForDisplay(ht);
    if (m) el.textContent = fmt(m);
  }

  update();

  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || !v.price) return;
    state.priceTTC = parseInt(v.price, 10);
    if (cta) {
      cta.dataset.price = v.price;
      cta.dataset.variantId = v.id;
    }
    update();
  });

  // getAllPricesForProduct est exposé par le script greenleaze chargé en async
  // (greenleaze-abonnement-product) : recalculer quand il est prêt / réactualisé.
  window.addEventListener('greenleazePriceActualize', update);

  // Tracking du clic « Louer » : event header partagé menu_interaction (cf. product-footer-cta.js,
  // data-layer-tracking.md). En plus de l'event rent_bike natif déclenché via .greenleaze-button-product
  // (mirroir d'« Acheter » qui combine add_to_cart natif + menu_interaction).
  if (cta) {
    cta.addEventListener('click', function () {
      var data = {
        menu_location: 'product_price_block',
        menu_parent: '',
        section_name: '',
        menu_label: 'Louer',
      };
      if (typeof window.trackEvent === 'function') {
        window.trackEvent('menu_interaction', data);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'menu_interaction' }, data));
      }
    });
  }
})();
